// IE 2026 09 26 / ODOO-… (заказ Игоря: виды панели страниц): СХЕМА СТРАНИЦЫ из её раскладки — вид «Previews» панели страниц (п. 2.3, этап 1).
// Мгновенно, без картинок и без данных: строки страницы (PAGE.attrs = doc.pages записи PAGE) → прямоугольники виджетов, которые откроются со страницей,
// в процентах рабочей области страницы (0…100 по обеим осям). Правила — те же, что у открытия страницы и её раскладки:
//   · виджет — строка с widget либо node.relation_segment (mainStore.scan_widgets_onOpening); use === false — строки нет вместе с подчинёнными;
//     открывается — в наборе открытия (opts.openIds: личный набор opens либо умолчания страницы — mainStore.page_openSet), без набора — onOpening строки;
//   · свободный (layout.free) — left / top / width / height в % рабочей области (без размеров — 40 × 30, как mainStore.layout_to_styleWidget);
//   · закреплённый — поток полосами (MainArea.calculatePage_rem0_flow → layoutFlow → applyFlow): слева направо, перенос при выходе за 100 % или по
//     new_row; размер — layout.width / height (%); последний узел полосы дотягивается до края, последняя полоса — до низа (стретчи страницы);
//   · строка-группа раскладки — строка БЕЗ своего виджета, но с onOpening: AttrTab — колонка («сверху вниз»), иначе ряд; группа создаётся
//     лениво — только когда в неё попал открываемый виджет (как containerOf в MainArea); меню-группы страницы (Widgets / Calc / More — без onOpening)
//     раскладку не создают: их виджеты ложатся в родителя.
// Минимумы записи виджета (doc.widthMin_rem / heightMin_rem) панели страниц неизвестны — у закреплённой строки без размеров взят DEF (50 × 50 %).
// Закреплённые, не влезшие по высоте, на странице уходят в свободные окна / прокрутку — в схеме ось Y сжимается, чтобы видно было все.
// Схема — приближение для узнавания страницы, а не точная копия экрана.

export const PAGE_SCHEMA_DEF = { w: 50, h: 50, freeW: 40, freeH: 30 }
const EPS = 1e-6
const num = (v) => { const n = Number(v); return Number.isFinite(n) ? n : null }
const pct = (v) => { const n = num(v); return n === null ? null : Math.max(0, Math.min(100, n)) }

// значок прямоугольника: вкладка, на которой откроется виджет (layout.tab), иначе значок строки (node.pi / cssClass-глиф), иначе по сегменту
const TAB_ICONS = { tabChart: 'pi pi-chart-line', tabMap: 'pi pi-map', tabGraph: 'pi pi-share-alt', tabGanttMoves: 'pi pi-align-left', tabGantt: 'pi pi-align-left',
    tabTreeMap: 'pi pi-th-large', tabBubbles: 'pi pi-circle', tabPivot: 'pi pi-table', tabSheet: 'pi pi-table', tabMetrics: 'pi pi-bullseye', tabAnalysis: 'pi pi-chart-bar',
    tabHeatmap: 'pi pi-th-large', tabHeatmapGrid: 'pi ie-ico-heatmap-pie' }   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: вкладка Heatmap списка); IE 2026 11 01 / ODOO-350449 (заказ Игоря: теплова карта на базі таблиці — порівняльна вкладка)   // IE 2026 11 03 / ODOO-350449 (heatmap tab swap): таблица теплокарты — иконка круговых пузырей
const glyphOf = (c) => {
    const keep = String(c || '').split(/\s+/).filter(x => /^(pi|pi-[\w-]+|ie-ico-[\w-]+)$/.test(x))
    return keep.some(x => x !== 'pi') ? (keep.includes('pi') || keep.some(x => x.startsWith('ie-ico-')) ? keep.join(' ') : 'pi ' + keep.join(' ')) : ''
}
export function pageSchema_icon(row) {
    const tab = row && row.layout && row.layout.tab
    if (tab && TAB_ICONS[tab]) return TAB_ICONS[tab]
    const own = glyphOf(row && row.node && row.node.pi) || glyphOf(row && row.cssClass) || glyphOf(row && row.pi)
    if (own) return own
    const seg = String((row && ((row.node && row.node.relation_segment) || row.segment)) || '')
    if (seg.startsWith('WIDGET-REPORT')) return 'pi pi-table'
    if (seg.startsWith('WIDGET-LIST')) return 'pi pi-list'
    if (seg.startsWith('TASKS')) return 'pi pi-play'
    if (seg.startsWith('DATA-SOURCE')) return 'pi pi-database'
    return 'pi pi-window-maximize'
}

// строки страницы → узлы раскладки: { root, free: [...] }; opts.openIds — набор открытия (массив / Set id), null — onOpening строк
export function pageSchema_nodes(rows, opts = {}) {
    const openSet = opts.openIds ? new Set([...opts.openIds].map(String)) : null
    const root = { type: 'group', dir: 'row', layout: {}, root: true, children: [] }
    const free = []
    let order = 0
    const walk = (list, container) => {
        for (const r of list || []) {
            if (!r || r.use === false) continue
            const id = r.widget || (r.node && r.node.relation_segment ? r.node.value : null)
            const want = id ? (openSet ? openSet.has(String(id)) : !!r.onOpening) : false
            if (id && want) {
                const lay = r.layout || {}
                const base = { id: String(id), title: String((r.node && r.node.valueStr) || r.title || id), icon: pageSchema_icon(r), segment: String((r.node && r.node.relation_segment) || r.segment || ''),
                    tab: lay.tab || '', multiply: !!(r.multiply && r.multiply.widget), order: order++,
                    lay: { free: !!lay.free, width: pct(lay.width), height: pct(lay.height), left: pct(lay.left), top: pct(lay.top) } }   // IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): раскладка строки — «размер изменился»
                if (lay.free) {
                    const hasSize = lay.width || lay.height
                    free.push({ ...base, free: true, x: hasSize ? (pct(lay.left) ?? 0) : 0, y: hasSize ? (pct(lay.top) ?? 0) : 0,
                        w: (hasSize ? pct(lay.width) : null) || PAGE_SCHEMA_DEF.freeW, h: (hasSize ? pct(lay.height) : null) || PAGE_SCHEMA_DEF.freeH })
                } else {
                    container().children.push({ type: 'widget', ...base, free: false, new_row: !!lay.new_row,
                        w: Math.min(pct(lay.width) || PAGE_SCHEMA_DEF.w, 100), h: Math.min(pct(lay.height) || PAGE_SCHEMA_DEF.h, 100) })
                }
            }
            if (!r.attrs || !r.attrs.length) continue
            if (!id && r.onOpening) {
                // строка-группа раскладки: узел создаётся при первом своём виджете, в позиции этого виджета
                const lay = r.layout || {}
                let node = null
                const own = () => {
                    if (!node) {
                        node = { type: 'group', dir: (r.attr_type || (r.node && r.node.attr_type)) === 'AttrTab' ? 'col' : 'row', layout: { width: pct(lay.width) || 0, height: pct(lay.height) || 0 },
                            new_row: !!lay.new_row, title: String(r.title || (r.node && (r.node.valueStr || r.node.value)) || ''), children: [] }
                        container().children.push(node)
                    }
                    return node
                }
                walk(r.attrs, own)
            } else {
                walk(r.attrs, container)   // меню-группа (Widgets / Calc / More) и подчинённые строки виджета — в том же контейнере
            }
        }
    }
    walk(rows, () => root)
    return { root, free }
}

// раскладка полосами — порт MainArea.layoutFlow (единицы — % страницы: ширина и высота страницы = 100)
function layoutFlow(group, limitW, limitH, forceStretch = false) {
    const lay = group.layout || {}
    const minW = lay.width || 0, minH = lay.height || 0
    const W = forceStretch ? limitW : (minW || limitW)
    const H = forceStretch ? limitH : (minH || limitH)
    const isRow = group.dir !== 'col'
    const stretchMain = group.root || forceStretch || (isRow ? !!minW : !!minH)
    const stretchCross = group.root || forceStretch || (isRow ? !!minH : !!minW)
    const limitMain = isRow ? W : H, limitCross = isRow ? H : W
    for (const node of group.children) if (node.type === 'group') { layoutFlow(node, W, H); node._w0 = node.w; node._h0 = node.h }
    const mainOf = (n) => isRow ? n.w : n.h
    const crossOf = (n) => isRow ? n.h : n.w
    const setMain = (n, v) => { if (isRow) n.w = v; else n.h = v }
    const setCross = (n, v) => { if (isRow) n.h = v; else n.w = v }
    const lanes = []
    let lane = null
    for (const node of group.children) {
        if (lane && (node.new_row || lane.main + mainOf(node) > limitMain + EPS)) {
            const last = lane.nodes[lane.nodes.length - 1]
            if (lane.main < limitMain - EPS) { setMain(last, mainOf(last) + limitMain - lane.main); lane.main = limitMain }
            lane = null
        }
        if (!lane) { lane = { cross: lanes.length ? lanes[lanes.length - 1].cross + lanes[lanes.length - 1].size : 0, main: 0, size: 0, nodes: [] }; lanes.push(lane) }
        node._main = lane.main; node._cross = lane.cross
        lane.main += mainOf(node); lane.size = Math.max(lane.size, crossOf(node)); lane.nodes.push(node)
    }
    let contentMain = 0, contentCross = 0
    lanes.forEach((ln, i) => {
        const lastLane = i === lanes.length - 1
        if (lastLane && stretchCross && limitCross - ln.cross > ln.size + EPS) ln.size = limitCross - ln.cross
        if (lastLane && stretchMain && ln.main < limitMain - EPS) { const last = ln.nodes[ln.nodes.length - 1]; setMain(last, mainOf(last) + limitMain - ln.main); ln.main = limitMain }
        for (const node of ln.nodes) setCross(node, ln.size)
        contentMain = Math.max(contentMain, ln.main); contentCross = ln.cross + ln.size
    })
    group.w = Math.max(forceStretch ? limitW : minW, isRow ? contentMain : contentCross)
    group.h = Math.max(forceStretch ? limitH : minH, isRow ? contentCross : contentMain)
    for (const node of group.children) {
        if (node.type === 'group' && (node.w > node._w0 + EPS || node.h > node._h0 + EPS)) layoutFlow(node, node.w, node.h, true)
    }
}
function applyFlow(group, left, top, out) {
    const isRow = group.dir !== 'col'
    for (const node of group.children) {
        const x = left + (isRow ? node._main : node._cross)
        const y = top + (isRow ? node._cross : node._main)
        if (node.type === 'widget') out.push({ id: node.id, title: node.title, icon: node.icon, segment: node.segment, tab: node.tab, multiply: node.multiply, order: node.order, lay: node.lay, free: false, x, y, w: node.w, h: node.h })   // IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): lay
        else applyFlow(node, x, y, out)
    }
}

// строки страницы → схема: { rects: [{ id, title, icon, segment, tab, multiply, free, x, y, w, h }], docked, free, count, empty };
// закреплённые — по порядку раскладки, свободные — поверх, в порядке строк. Координаты округлены до 0.01 %
export function pageSchema_build(rows, opts = {}) {
    const { root, free } = pageSchema_nodes(rows, opts)
    const docked = []
    if (root.children.length) { layoutFlow(root, 100, 100); applyFlow(root, 0, 0, docked) }
    // закреплённые, вылезшие за низ страницы, — сжатие оси Y, чтобы в схеме были видны все
    const bottom = docked.reduce((m, r) => Math.max(m, r.y + r.h), 0)
    const k = bottom > 100 + EPS ? 100 / bottom : 1
    const r2 = (v) => Math.round(v * 100) / 100
    const rects = []
    for (const r of docked) rects.push({ ...r, x: r2(r.x), y: r2(r.y * k), w: r2(Math.min(r.w, 100 - r.x)), h: r2(r.h * k) })
    for (const r of free) {
        const w = Math.min(r.w, 100), h = Math.min(r.h, 100)
        rects.push({ ...r, x: r2(Math.min(r.x, 100 - w)), y: r2(Math.min(r.y, 100 - h)), w: r2(w), h: r2(h) })
    }
    return { rects, docked: docked.length, free: free.length, count: rects.length, empty: !rects.length, squeezed: k < 1 }
}

export default { pageSchema_build, pageSchema_nodes, pageSchema_icon, PAGE_SCHEMA_DEF }
